import { DashboardLessonProgressFilters } from '@/data/services/dashboardLessonProgress';

type UnitLessonProgressesParams = {
  unitId?: number;
  courseProgressId?: number;
};

export default function unitLessonProgressesQueryFilters({
  unitId,
  courseProgressId,
}: UnitLessonProgressesParams): DashboardLessonProgressFilters {
  return {
    courseProgressId: courseProgressId ? [courseProgressId] : undefined,
    lessonBlockId: unitId ? [unitId] : undefined,
    orderBy: 'scheduled_lesson_order',
  };
}
